import React from "react";
import { FormGroup, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";

import Input from "../../../../components/common/input/Input";
import Button from "../../../../components/common/button/Button";
import Error from "../../../../components/common/error/Error";
import { RESET_PASSWORD_FORM } from "../../../../actions/resetPassword.actions";
import {
  required,
  email,
  minLength,
  isEqual
} from "../../../../utils/forms/validators";
import styles from "./ResetPassword.scss";

const emailValidation = email("Please enter a valid email address.");
const passwordValidation = minLength(
  8,
  "Password must be at least 8 characters."
);
const passwordConfirm = isEqual(
  "password",
  "password_confirmation",
  "Passwords are not the same"
);

class ResetPassword extends React.Component {
  render() {
    const { invalid, submitting, pristine, handleSubmit } = this.props;

    return (
      <section>
        <section className={styles.forgotPassword}>
          <div className={styles.content}>
            <h2 className={styles.title}>Reset Your Password</h2>

            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <div className={styles.subtitle}>
                  <span>Enter your email and new password</span>
                </div>

                <FormGroup>
                  <Field
                    name="email"
                    type="text"
                    placeholder="Email Address"
                    component={Input}
                    validate={[required, emailValidation]}
                    autoComplete="off"
                  />

                  <Field
                    name="password"
                    type="password"
                    placeholder="New Password"
                    component={Input}
                    validate={[required, passwordValidation]}
                    showPasswordIcon={true}
                    autoComplete="off"
                  />

                  <Field
                    name="password_confirmation"
                    type="password"
                    placeholder="Confirm New Password"
                    component={Input}
                    validate={[required, passwordValidation, passwordConfirm]}
                    showPasswordIcon={true}
                    autoComplete="off"
                  />
                </FormGroup>

                <Button
                  isDisabled={invalid || submitting || pristine}
                  isPrimary
                  type="submit"
                  size="large"
                  label="Reset your password"
                />

                <Error />

                <div className={styles.subtitle}>
                  <span>
                    <Link to="/log-in">Go back to login</Link>
                  </span>
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

export default reduxForm({
  form: RESET_PASSWORD_FORM
})(ResetPassword);



// WEBPACK FOOTER //
// ./src/routes/common/resetPassword/components/ResetPassword.js